import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DescriptionAlerts from './DescriptionAlerts';
import ClientProvider from './client';
export default createDemo(import.meta.url, DescriptionAlerts, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/alert/demos/description/DescriptionAlerts.tsx",
    "fileName": "DescriptionAlerts.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Alert from '@mui/material/Alert';\nimport AlertTitle from '@mui/material/AlertTitle';\nimport Stack from '@mui/material/Stack';\n\nexport default function DescriptionAlerts() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={2}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Alert severity=\"success\">\n        <AlertTitle>Success</AlertTitle>\n        This is a success Alert with an encouraging title.\n      </Alert>\n      <Alert severity=\"info\">\n        <AlertTitle>Info</AlertTitle>\n        This is an info Alert with an informative title.\n      </Alert>\n      <Alert severity=\"warning\">\n        <AlertTitle>Warning</AlertTitle>\n        This is a warning Alert with a cautious title.\n      </Alert>\n      <Alert severity=\"error\">\n        <AlertTitle>Error</AlertTitle>\n        This is an error Alert with a scary title.\n      </Alert>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 26,
        "focusedLines": 16,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Alert from '@mui/material/Alert';\nimport AlertTitle from '@mui/material/AlertTitle';\nimport Stack from '@mui/material/Stack';\n\nexport default function DescriptionAlerts() {\n  return (\n    <Stack sx={{ width: '100%' }} spacing={2}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Alert severity=\"success\">\n        <AlertTitle>Success</AlertTitle>\n        This is a success Alert with an encouraging title.\n      </Alert>\n      <Alert severity=\"info\">\n        <AlertTitle>Info</AlertTitle>\n        This is an info Alert with an informative title.\n      </Alert>\n      <Alert severity=\"warning\">\n        <AlertTitle>Warning</AlertTitle>\n        This is a warning Alert with a cautious title.\n      </Alert>\n      <Alert severity=\"error\">\n        <AlertTitle>Error</AlertTitle>\n        This is an error Alert with a scary title.\n      </Alert>\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "success",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "AlertTitle"
              ],
              ">Success</",
              [
                "span",
                "pl-c1 di-jsx",
                "AlertTitle"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            "        This is a success Alert with an encouraging title."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 12
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "info",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "AlertTitle"
              ],
              ">Info</",
              [
                "span",
                "pl-c1 di-jsx",
                "AlertTitle"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            "        This is an info Alert with an informative title."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "warning",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "AlertTitle"
              ],
              ">Warning</",
              [
                "span",
                "pl-c1 di-jsx",
                "AlertTitle"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            "        This is a warning Alert with a cautious title."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "severity"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "error",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "AlertTitle"
              ],
              ">Error</",
              [
                "span",
                "pl-c1 di-jsx",
                "AlertTitle"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            "        This is an error Alert with a scary title."
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Alert"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 26,
    "focusedLines": 16,
    "collapsible": true,
    "externals": [
      "@mui/material/Alert",
      "@mui/material/AlertTitle",
      "@mui/material/Stack"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
